import { Component, OnInit, Input, Output, EventEmitter  } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ArticleService } from 'src/app/service/article.service';

@Component({
  selector: 'app-select-assistance-package',
  templateUrl: './select-assistance-package.component.html',
  styleUrls: ['./select-assistance-package.component.scss']
})
export class SelectAssistancePackageComponent implements OnInit {

  constructor(
    private fb: FormBuilder,
    private articleSrv: ArticleService
  ) { }
  selectedAP = this.fb.group({
    attributeId: new FormControl('', Validators.required),
    tier: new FormControl('', Validators.required),
    price: new FormControl('', Validators.required)
  }) 
  @Input() orderArticle: any;
  @Output() event = new EventEmitter<any>();
  articleAttributeList: any;
  article: any;
  tiers: any = [];

  changeId(id){
    this.selectedTier(id);
    this.selectedAP.value.attributeId = id;
  }

  selectedTier(id){
    let tier
    
    this.tiers.forEach(element => {
      if(element.attribute_value_id == id){
        tier = element
      }
    });
    switch (id) {
      case '12':
        this.selectedAP.value.tier = tier.attribute_value_culture;
        this.selectedAP.value.price = '10';
        this.articleAttributeList = {
          attributeId: tier.attribute_id,
          attributeName: tier.attribute_culture,
          attributeValue: tier.attribute_value_culture,
          attributeValueId: tier.attribute_value_id
        }
        break;
      case '13':
        this.selectedAP.value.tier = tier.attribute_value_culture
        this.selectedAP.value.price = '25'
        this.articleAttributeList = {
          attributeId: tier.attribute_id,
          attributeName: tier.attribute_culture,
          attributeValue: tier.attribute_value_culture,
          attributeValueId: tier.attribute_value_id
        }
        break;
      case '14':
        this.selectedAP.value.tier = tier.attribute_value_culture
        this.selectedAP.value.price = '50'
        this.articleAttributeList = {
          attributeId: tier.attribute_id,
          attributeName: tier.attribute_culture,
          attributeValue: tier.attribute_value_culture,
          attributeValueId: tier.attribute_value_id
        }
        break;
      case '15':
        this.selectedAP.value.tier = tier.attribute_value_culture
        this.selectedAP.value.price = '100'
        this.articleAttributeList = {
          attributeId: tier.attribute_id,
          attributeName: tier.attribute_culture,
          attributeValue: tier.attribute_value_culture,
          attributeValueId: tier.attribute_value_id
        }
        break; 
      default:
        break;
    }
  }

  next(){
    let orderArticle = {
      id: this.article.id,
      title: this.article.title,
      price: this.selectedAP.value.price,
      attributes: [this.articleAttributeList],
      quantity: 1
    }
    this.orderArticle = orderArticle
    this.event.emit(this.orderArticle)
  }

  async ngOnInit() {
    await this.articleSrv.getArticleById(3).then( async (articles: any) =>{
      articles.forEach( async obj => {
        if(obj.id == 3){
          this.article = obj
        }
      });
      await this.articleSrv.getArticleAttributeValues(this.article.id).then( values =>{
        this.tiers = values;
        //selecting id of first tier
        this.changeId('12');
        this.selectedTier(this.selectedAP.value.attributeId);
      })
    })

  }

}
